// Chart SVGs have fixed pixel widths measured from the screen viewport and no
// viewBox, so they overflow the narrower printed page. Stamping a viewBox lets
// print CSS scale them (see app.scss).

const PrintViewBoxAttribute = 'data-print-viewbox';

export const preparePrintLayout = () => {
  document.querySelectorAll<SVGSVGElement>('svg[width]').forEach((svg) => {
    const width = Number(svg.getAttribute('width'));
    const height = Number(svg.getAttribute('height'));
    // Number(null)/Number('') are 0, so a missing height would yield an invisible viewBox.
    if (svg.hasAttribute('viewBox') || !(width > 0) || !(height > 0)) {
      return;
    }
    svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
    svg.setAttribute(PrintViewBoxAttribute, 'true');
  });
};

export const restoreScreenLayout = () => {
  document.querySelectorAll<SVGSVGElement>(`svg[${PrintViewBoxAttribute}]`).forEach((svg) => {
    svg.removeAttribute('viewBox');
    svg.removeAttribute(PrintViewBoxAttribute);
  });
};

export const initPrintLayoutListeners = () => {
  window.addEventListener('beforeprint', preparePrintLayout);
  window.addEventListener('afterprint', restoreScreenLayout);
};
